(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/table-of-draw-events.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/table-of-draw-events.js');
"use strict";



const {
  useEffect,
  useRef
} = React;
const {
  productIds,
  helpers: {
    isFulltraff,
    isMaltipset
  }
} = svs.utils.products;
const {
  ReactButtonBet
} = svs.components;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_SM
} = svs.components.lbUtils.useMediaQuery;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  signIndexToTitle
} = svs.components.sport.tipsenShared;
const {
  is1X2
} = svs.components.sport.quickplayModal.helpers;


const defaultProps = {
  drawData: null,
  pixData: null
};

const useMemoizedMinHeight = _ref => {
  let {
    ref,
    hasData
  } = _ref;
  useEffect(() => {
    if (ref.current) {
      if (hasData) {
        ref.current.removeAttribute('style');
      }
      const height = ref.current.getBoundingClientRect().height;
      ref.current.setAttribute('style', "min-height: ".concat(height, "px;"));
    }
  });
};
const MaltipsetRowsDescription = _ref2 => {
  let {
    amountRows
  } = _ref2;
  const numbers = [];
  for (let i = 1; i <= amountRows; i++) {
    numbers.push(i);
  }
  return React.createElement("div", {
    className: "table-of-events-goal-type-rows"
  }, React.createElement("span", {
    className: "margin-right-half"
  }, "Rader"), numbers.map(rowNumber => React.createElement("div", {
    className: "table-of-events-goal-type-rows-selection",
    key: "".concat(rowNumber, "_rowNumber")
  }, rowNumber)));
};

const TableOfDrawEvents = _ref3 => {
  var _pixData$wagerBoardDa, _pixData$wagerBoardDa2;
  let {
    branding,
    drawData,
    pixData
  } = _ref3;
  const {
    productId,
    events
  } = drawData || {};
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  const isMaltipsetSrow = isMaltipset(productId) && (pixData === null || pixData === void 0 || (_pixData$wagerBoardDa = pixData.wagerBoardData) === null || _pixData$wagerBoardDa === void 0 ? void 0 : _pixData$wagerBoardDa.maltipset.length) > 1;
  return React.createElement("div", {
    className: "padding-left-2 padding-right-2"
  }, React.createElement("div", {
    className: "f-medium u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60 fc-opacity-white-80"
  }, React.createElement("div", null, "Match"), React.createElement("div", {
    "data-testid": "table-of-events-goal-type"
  }, isMaltipsetSrow ? React.createElement(MaltipsetRowsDescription, {
    amountRows: pixData === null || pixData === void 0 || (_pixData$wagerBoardDa2 = pixData.wagerBoardData) === null || _pixData$wagerBoardDa2 === void 0 ? void 0 : _pixData$wagerBoardDa2.maltipset.length
  }) : _resolveGoalType(productId))), events.map((eventItem, eventIndex) => React.createElement(MatchRow, {
    branding: branding,
    eventIndex: eventIndex,
    eventItem: eventItem,
    isMobile: isMobile
    ,
    key: "".concat(eventItem.captionShort, "_").concat(eventIndex),
    pixData: pixData,
    productId: productId
  })));
};
TableOfDrawEvents.defaultProps = defaultProps;

const MatchRow = _ref4 => {
  let {
    eventItem,
    eventIndex,
    branding,
    productId,
    pixData,
    isMobile
  } = _ref4;
  const ref = useRef();
  useMemoizedMinHeight({
    ref,
    hasData: Boolean(pixData)
  });

  const {
    captionShort,
    captionLong,
    infoLine,
    outcomesAsList
  } = eventItem;
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60 notranslate".concat(!isMaltipset(productId) ? ' padding-top padding-bottom u-flex-align-items-center' : ''),
    key: "".concat(captionShort, "-").concat(eventIndex),
    ref: ref
  }, React.createElement("div", {
    className: "".concat(isMaltipset(productId) ? ' margin-top margin-bottom' : ''),
    "data-testid": "event-".concat(eventIndex, "-description")
  }, React.createElement("div", null, "".concat(eventIndex + 1, ". ").concat(isMobile ? captionShort : captionLong)), Boolean(infoLine) && React.createElement("div", {
    className: "padding-left-1 fc-grey-400"
  }, infoLine)), React.createElement("div", {
    className: "u-flex f-100 fc-white quickplay-modal-outcomes",
    "data-testid": "event-".concat(eventIndex, "-outcomes")
  }, React.createElement(EventOutcomes, {
    branding: branding,
    eventIndex: eventIndex,
    outcomesAsList: outcomesAsList,
    pixData: pixData,
    productId: productId
  })));
};

const EventOutcomes = _ref5 => {
  let {
    eventIndex,
    outcomesAsList,
    branding,
    productId,
    pixData
  } = _ref5;
  if (isFulltraff(productId)) {
    var _pixData$signsByEvent;
    const signs = (pixData === null || pixData === void 0 || (_pixData$signsByEvent = pixData.signsByEventForOutput) === null || _pixData$signsByEvent === void 0 || (_pixData$signsByEvent = _pixData$signsByEvent.fulltraff) === null || _pixData$signsByEvent === void 0 ? void 0 : _pixData$signsByEvent[eventIndex]) || [];
    const labels = signIndexToTitle[EventTypeId.GOAL_COUNT];
    return React.createElement(React.Fragment, null, signs.map((isSelected, signIndex) => {
      if (isSelected) {
        return React.createElement("div", {
          className: "quickplay-modal-outcomes-circle f-bold bg-fulltraff-700",
          key: labels[signIndex]
        }, labels[signIndex]);
      }
      return null;
    }).filter(Boolean));
  }
  if (isMaltipset(productId)) {
    var _pixData$signsByEvent2;
    const signs = (pixData === null || pixData === void 0 || (_pixData$signsByEvent2 = pixData.signsByEventForOutput) === null || _pixData$signsByEvent2 === void 0 || (_pixData$signsByEvent2 = _pixData$signsByEvent2.maltipset) === null || _pixData$signsByEvent2 === void 0 ? void 0 : _pixData$signsByEvent2.map(board => board[eventIndex])) || [];
    return React.createElement(React.Fragment, null, signs.map((isSelected, signIndex) => {
      if (isSelected) {
        return React.createElement("div", {
          className: "quickplay-modal-selection"
          ,
          key: "".concat(eventIndex, "_").concat(signIndex)
        }, React.createElement(ReactButtonBet, {
          "aria-hidden": "true",
          branding: branding,
          className: "margin-half",
          label: "X",
          selected: true,
          size: "200",
          tabIndex: "-1"
        }));
      }
      return React.createElement("div", {
        className: "quickplay-modal-selection-empty"
        ,
        key: "".concat(eventIndex, "_").concat(signIndex)
      });
    }).filter(Boolean));
  }
  if (is1X2(productId)) {
    var _pixData$signsByEvent3;
    const signs = (pixData === null || pixData === void 0 || (_pixData$signsByEvent3 = pixData.signsByEventForOutput) === null || _pixData$signsByEvent3 === void 0 || (_pixData$signsByEvent3 = _pixData$signsByEvent3.game1X2) === null || _pixData$signsByEvent3 === void 0 ? void 0 : _pixData$signsByEvent3[eventIndex]) || [];
    const labels = outcomesAsList || signIndexToTitle[EventTypeId.EVENT_1X2];
    return React.createElement(React.Fragment, null, signs.map((isSelected, signIndex) => React.createElement(ReactButtonBet, {
      branding: branding,
      className: "margin-half",
      disabled: !labels[signIndex]
      ,
      key: "".concat(signIndex, "_").concat(labels[signIndex]),
      label: labels[signIndex],
      selected: isSelected,
      size: "200",
      tabIndex: "-1"
    })));
  }
  if (productId === productIds.BOMBEN) {
    var _pixData$signsByEvent4;
    const eventResults = (pixData === null || pixData === void 0 || (_pixData$signsByEvent4 = pixData.signsByEventForOutput) === null || _pixData$signsByEvent4 === void 0 || (_pixData$signsByEvent4 = _pixData$signsByEvent4.bomben) === null || _pixData$signsByEvent4 === void 0 ? void 0 : _pixData$signsByEvent4[eventIndex]) || [];
    return React.createElement("div", {
      className: "quickplay-column"
    }, eventResults.map(_ref6 => {
      let [labelOne, labelTwo] = _ref6;
      return React.createElement("div", {
        className: "quickplay-row-signs",
        key: "bomb_".concat(labelOne, "_").concat(labelTwo)
      }, React.createElement(ReactButtonBet, {
        branding: branding,
        className: "margin-half",
        label: labelOne.toString(),
        selected: true,
        size: "200",
        tabIndex: "-1"
      }), "-", React.createElement(ReactButtonBet, {
        branding: branding,
        className: "margin-half",
        label: labelTwo.toString(),
        selected: true,
        size: "200",
        tabIndex: "-1"
      }));
    }));
  }
  return null;
};

function _resolveGoalType(productId) {
  switch (productId) {
    case productIds.FULLTRAFF:
      return 'Antal Mål';
    case productIds.MALTIPSET:
      return 'Målrikaste Matcher';
    case productIds.BOMBEN:
    case productIds.MATCHEN:
      return 'Resultat';
    case productIds.CHALLENGE:
      return '';
    default:
      return 'Tippa resultat';
  }
}
setGlobal('svs.components.sport.quickplayModal.TableOfDrawEvents', TableOfDrawEvents);

 })(window);